<template>
  <div>
    <div class="row"></div>
    <div v-if="productBrand === 'Poss'" class="col s12 z-depth-1 white logoBg">
      <slot />
    </div>
    <div v-if="productBrand === 'RailPredict'" class="col s12 z-depth-1 white logoRailPredictBg">
      <slot />
    </div>
  </div>
</template>

<script>
import AuthenticationService from '../../services/AuthenticationService'

export default {
  data () {
    return {
      currentUser: AuthenticationService.getUser(),
      productBrand: 'Poss'
    }
  },
  watch: {
    'currentUser': {
      immediate: true,
      handler: function (val, oldVal) {
        if (this.currentUser !== null) {
          switch (this.currentUser.OrganisationId) {
            case 46: // Friedrich Hippe
            case 81: // KVB
              this.productBrand = 'RailPredict'
              break

            // Default Strukton logo
            default:
              this.productBrand = 'Poss'
              break
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .logoRailPredictBg {
    background-image: url("../../assets/logo-railpredict2.png");
    background-repeat: no-repeat;
    background-position: 99% 10px;
  }
  .logoBg {
    background-image: url("../../assets/logo-strukton.jpg");
    background-repeat: no-repeat;
    background-position: 99% 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reportItems/Page.vue